import { useEffect, useState, useCallback } from "react";
import { Footer } from "../components/layout/footer";
import { Map } from "../components/layout/map";
import { useIsMobile } from "../hooks/useIsMobile";
import { LocationProvider } from "../hooks/useLocation";
import { Experience } from "../pages/experience";
import { Formation } from "../pages/formation";
import { Home } from "../pages/home";
import { Portfolio } from "../pages/portfolio";
import { Solutions } from "../pages/solutions";
import styles from "./App.module.scss";

function preloadImages(): Promise<void> {
  const images = Array.from(document.images);

  return Promise.all(
    images.map(
      (img) =>
        new Promise<void>((resolve) => {
          img.onload = () => resolve();
          img.onerror = () => resolve();
        })
    )
  ).then(() => undefined);
}

function App() {
  const isMobile = useIsMobile();
  const [loading, setLoading] = useState(true);
  const [footerHeight, setFooterHeight] = useState<number>(0);

  useEffect(() => {
    preloadImages().then(() => setLoading(false));
  }, []);

  // Callback pour recevoir la hauteur du footer
  const handleFooterHeight = useCallback((height: number) => {
    setFooterHeight(height);
  }, []);

  return (
    <LocationProvider>
      <div
        className={styles.app}
        style={{ marginBottom: footerHeight ? `${footerHeight}px` : undefined }}
      >
        {loading && (
          <div className={styles.loaderOverlay}>
            <div className={styles.loader} />
          </div>
        )}
        <Home id="home" />
        <div className={styles.content}>
          <Solutions id="solutions" />
          <div className={styles.located}>
            <div className={styles.locatedContent}>
              <Experience id="experience" />
              <Formation id="formation" />
            </div>
            {!isMobile && <Map />}
          </div>
          <Portfolio id="portfolio" />
        </div>
        <Footer onHeightChange={handleFooterHeight} />
      </div>
    </LocationProvider>
  );
}

export default App;
